import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { RouterModule } from '@angular/router';
import { AccountYacareComponent } from './account-yacare.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/core/material/material.module';
import { Permissions } from 'src/app/core/enums/permissions.enum';
import { AuthGuard } from 'src/app/core/guards/auth.guard';

@NgModule({
  declarations: [AccountYacareComponent],
  exports: [AccountYacareComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: AccountYacareComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'components.menu.balance',
          title: 'Saldo Yacaré',
          permission: [Permissions.INICIO],
          status: true
        }
      }
    ]),
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule.forChild({
      isolate: false
    })
  ]
})
export class AccountYacareModule {}
